export enum MMMClientState {
  NOT_SET = "not_set",
  POPULATING_DATA = "inputting_data",
  REVIEWING_MODEL = "blessing_model",
  CREATING_SETTINGS = "creating_settings",
  PREPARING_MIX = "preparing_mix",
  ADOPTING_MIX = "adopting_mix",
  TRACKING_MIX = "tracking_mix",
  REVIEWING_PERIOD = "reviewing",
}

type MMMCycleDataInputStageShape = {
  id: string;
  has_updated_spend: boolean;
  has_updated_adi: boolean;
  has_updated_coe: boolean;
};

export type MMMClientCycleBase = {
  id: string;
  date_range: {
    start_date: string;
    end_date: string;
    id: number;
  };
  model: {
    id: number;
    is_blessed: boolean;
    model_path: string;
    create_northbeam_mmm_run_result?: number;
    run_result?: {
      cycle_dataset_path?: string;
    };
  };
  state: MMMClientState;
  is_current: boolean;
  is_errored: boolean;
  is_manually_overridden: boolean;
  breakdowns: string[];
  clientSettingsCount: number;
  cadenceInDays: number;
  hidden: boolean;
  name: string;
  cycleInputStage: MMMCycleDataInputStageShape | null;
};

export type MMMClientCycle = Omit<MMMClientCycleBase, "clientSettingsCount"> & {
  clientSettings: { id: string; name: string }[];
};
